__turbopack_context__.v({
  "controls": "RNAF0a_controls",
  "hr": "RNAF0a_hr",
  "iconButton": "RNAF0a_iconButton",
  "loadingStateWrapper": "RNAF0a_loadingStateWrapper",
  "productWrapperReplacements": "RNAF0a_productWrapperReplacements",
  "sliderContainerReplacements": "RNAF0a_sliderContainerReplacements",
  "sliderItemsReplacements": "RNAF0a_sliderItemsReplacements",
  "sliderWrapperReplacements": "RNAF0a_sliderWrapperReplacements",
  "title": "RNAF0a_title",
  "titleReplacements": "RNAF0a_titleReplacements",
  "wrapper": "RNAF0a_wrapper",
});
